/** @format */

export const viewTypes = {
  INCAPACITY: 'incapacidad',
  ANTECEDENTE: 'antecedentes',
  NO_PATOLOGICOS: 'noPatologicos'
}

export const ENDPOINTS_LISTS = {
  PEOPLE: 'people',
  MODULES: 'modules',
  USERS: 'users',
  ROLES: 'roles',
  INCAPACIDADES: 'incapacidades',
  PACIENTES: 'pacientes',
  DIAGNOSTICOS: 'diagnosticos',
  CONSULTAS: 'consultas'
}
